import React from 'react';
import { useInView } from 'react-intersection-observer';

import ContentfulImage from '../Common/ContentfulImage';
import RichTextConverter from '../Common/RichText/RichTextConverter';
import SmartLink from '../Common/SmartLink';
import * as styles from './G2Quote.module.scss';
import PageSection from './PageSection';

export default function G2Quote({ section }) {
  const { ref, inView } = useInView({
    threshold: 0.25,
    triggerOnce: true,
  });

  return (
    <PageSection
      slim={true}
      className={[styles.section, styles[section.backgroundColor.toLowerCase()]].join(' ')}
      data-analytics-component={'g2-quote'}
      data-analytics-id={section.title}
    >
      <div className={[styles.copy, inView ? styles.inView : ''].join(' ')} ref={ref}>
        <h2>{section.title}</h2>
        <div className={styles.content}>
          <ContentfulImage imageFragment={section.g2Badge} className={styles.badge} />
          <div>
            <RichTextConverter copy={section.quote} className={styles.quote} />
            {section.name && section.credentials && (
              <div className={styles.attribution}>
                <p>{section.name}</p>
                <p>{section.credentials}</p>
              </div>
            )}
            {section.callToAction && (
              <SmartLink to={section.callToAction.url} className={styles.cta}>
                {section.callToAction.linkText}
              </SmartLink>
            )}
          </div>
        </div>
      </div>
      <ContentfulImage
        imageFragment={section.image}
        lazy={true}
        className={[styles.image, inView ? styles.inView : ''].join(' ')}
      />
    </PageSection>
  );
}
